<template>
    <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9 10C11.7614 10 14 7.76142 14 5C14 2.23858 11.7614 0 9 0C6.23858 0 4 2.23858 4 5C4 7.76142 6.23858 10 9 10Z"
            fill="#38BDF8"
        />
        <path
            d="M6.364 11.3701H11.637C13.3247 11.3704 14.9431 12.0058 16.1364 13.1365C17.3296 14.2673 18 15.8008 18 17.3998V17.3998C18 17.5597 17.933 17.7129 17.8137 17.8259C17.6944 17.9389 17.5327 18.0024 17.364 18.0024H0.636C0.467322 18.0024 0.305553 17.9389 0.18628 17.8259C0.067007 17.7129 0 17.5597 0 17.3998H0C0 15.8007 0.670491 14.267 1.86397 13.1362C3.05745 12.0054 4.67616 11.3701 6.364 11.3701V11.3701Z"
            fill="#38BDF8"
        />
    </svg>
</template>

<script>
export default {
    name: 'UserIcon'
}
</script>
